import { FormattedMessage } from 'react-intl';

import {
  FIELD_AMOUNT,
  FIELD_MEMBERS,
  FIELD_MEMBER_SELECTED,
  COMMON_FIELD_NAMES,
} from './constants.fields';

export const MSG_CASH = 'afforda.assets.details.cash';

export const NEW_CASH = {
  memberId: '',
  amount: '',

  //
  isOpen: true,
};

export const CASH_FIELD_NAMES = {
  memberId: COMMON_FIELD_NAMES.memberId,
  amount: COMMON_FIELD_NAMES.amount,
};

export const FIELDS = ({ intl, members, disabledMembers }) => {
  return [
    ...FIELD_MEMBERS({ members, disabledMembers }),
    // Amount
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_AMOUNT,
      name: CASH_FIELD_NAMES.amount,
      label: <FormattedMessage id="afforda.assets.details.amount" />,
      placeholder: intl.formatMessage({
        id: 'afforda.assets.details.amount',
      }),
    },
  ];
};
